<template>
  <div class="app-list-wrap">
    <div class="main-body">
      <div class="main-content">
        <el-row class="main-content-row">
          <el-col :span="menuSetting == 'fold' ? 0 : 3" class="left-menu-content">
            <el-row v-show="menuSetting != 'fold' && screenWidth > 768">
              <el-col :span="24">
                <div class="logo">
                  <img src="@/assets/images/logo_white.png" alt="" />
                </div>
                <p class="system-title">人事管理</p>
              </el-col>
            </el-row>
            <el-menu
              default-active="/userList"
              class="el-menu-vertical-demo"
              :router="true"
              :collapse="menuSetting == 'fold' ? true : false"
              @open="handleOpen"
              @close="handleClose">
              <el-menu-item index="/userList">
                <i class="el-icon-user"></i>
                <span slot="title">用户管理</span>
              </el-menu-item>
              <el-menu-item index="/departmentList">
                <i class="el-icon-s-check"></i>
                <span slot="title">部门管理</span>
              </el-menu-item>
              <el-menu-item index="/logList">
                <i class="el-icon-search"></i>
                <span slot="title">日志管理</span>
              </el-menu-item>
            </el-menu>
          </el-col>
          <el-col :span="menuSetting == 'fold' ? 23 : 21" class="right-container">
            <router-view />
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Header from '@/components/Header.vue'
export default {
  data() {
    return {
      screenWidth: window.innerWidth, // 动态获取屏幕宽度
    }
  },
  components: {
    Header
  },
  computed: {
    ...mapGetters(["menuSetting"])
  },
  created() {
  },
  mounted() {
    document.title = '人事管理';
    window.addEventListener("resize", this.updateScreenWidth);
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
}
</script>

<style lang="scss" scoped>
.app-list-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f8f9fa;
  .main-body {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    .main-content {
      height: 100%;
      .main-content-row {
        height: 100%;
        overflow: hidden;
      }
      .system-title {
        font-size: 24px;
      }
      .left-menu-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #58ABF6;
        overflow: hidden;
        .system-title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 24px;
          color: #FFFFFF;
          line-height: 40px;
          text-align: center;
          font-style: normal;
        }
        .logo {
          text-align: center;
          margin: 20px 0;
          img {
            width: 132px;
            height: 36px;
            margin: 0 auto;
          }
        }
      }
      .right-container {
        height: 100%;
        border-radius: 12px;
        -webkit-box-shadow: 0 4px 8px rgba(31,35,41,.03),0 3px 6px -6px rgba(31,35,41,.05),0 6px 18px 6px rgba(31,35,41,.03);
        box-shadow: 0 4px 8px rgba(31,35,41,.03),0 3px 6px -6px rgba(31,35,41,.05),0 6px 18px 6px rgba(31,35,41,.03);
      }
    }
    .el-row {
      .el-menu {
        flex: 1;
        margin-top: 10px;
        background-color: #58ABF6;
        border: none;
        li {
          background-color: #58ABF6;
          span {
            color: #FFFFFF;
            font-size: 16px;
          }
          :deep(.el-sub-menu__icon-arrow) {
            color: #FFFFFF;
          }
          i {
            color: #FFFFFF;
          }
          &.is-active {
            background-color: #2A85D7;
          }
        }
      }
    }
  }
}
// 添加媒体查询
@media screen and (max-width: 768px) {
  .app-list-wrap {
    .main-body {
      .main-content {
        .left-menu-content {
          align-items: center;
        }
        .main-content-row {
          flex-direction: column;
          overflow: auto;
          .right-container {
            border-radius: 0;
          }
        }
      }
      .el-row {
        .el-menu {
          li {
            span {
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>
<style>
html, body {
  height: 100%;
}
#app {
  height: 100%;
}
</style>
